import React from 'react';

class FormatoSimplificado1347559PlanEmpresarialPlus_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347559 Plan Empresarial +';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347559_EMPRESARIAL_2024_V2.pdf?alt=media&token=03b5e83f-601b-4f0d-8f8c-97e925e40735';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347559PlanEmpresarialPlus_pdf